// ======================================================================
// FILE:
// src/modules/expense_management/claims/components/BusinessReferenceCard.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Business Reference Card
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import businessReferenceService
from "../services/businessReferenceService";

import BusinessReferenceLookupDialog
from "./BusinessReferenceLookupDialog";

export default function BusinessReferenceCard({
  data = {},
  onChange,
  readOnly = false,
  onSearch,
  onReset,
}) {

  // ==========================================================
  // HELPERS
  // ==========================================================

  const update = (field, value) => {

    onChange?.({

      ...data,

      [field]: value,

    });

  };

  const employeeSelected =     !!data.employee_id;

  const referenceLocked =     !!data.reference_id;

  // ==========================================================
  // STATE
  // ==========================================================

  const [  expenseSources,  setExpenseSources,] = useState([]);
  const [  referenceTypes,  setReferenceTypes,] = useState([]);
  // ==========================================================
// LOOKUP DIALOG STATE
// ==========================================================

const [
    showLookup,
    setShowLookup,
] = useState(false);

const [
    lookupRows,
    setLookupRows,
] = useState([]);

const [
    lookupColumns,
    setLookupColumns,
] = useState([]);

const [
    lookupLoading,
    setLookupLoading,
] = useState(false);

const [
    lookupSearch,
    setLookupSearch,
] = useState("");

// ==========================================================
// REFERENCE DETAILS COLLAPSE
// ==========================================================

const [
    showReferenceDetails,
    setShowReferenceDetails,
] = useState(false);

useEffect(() => {

    if (data.reference_id) {

        setShowReferenceDetails(false);

    }

}, [data.reference_id]);


// ==========================================================
  // RESET
  // ==========================================================

  function clearReference() {

    const clearedData = {

      ...data,

      expense_source: "",
      reference_type: "",

      reference_id: null,
      reference_number: "",

      service_ticket_id: null,
      service_visit_id: null,

      customer_id: null,
      installed_product_id: null,

      customer_name: "",
      contact_person: "",
      contact_number: "",

      engineer_name: "",
      assigned_engineer: "",

      ticket_no: "",
      visit_no: "",

      priority: "",
      category: "",
      status: "",
      visit_status: "",

      instance_id: "",
      engine_serial_no: "",

      visit_datetime: "",
      visit_start_time: "",
      visit_end_time: "",
      visit_duration_minutes: null,

      running_hours: "",

      start_address: "",
      end_address: "",

      work_done: "",
      observations: "",
      parts_used: "",
      resolution_summary: "",

    };

    onChange?.(
      clearedData
    );

  }

  function handleReset() {

    if (readOnly) {

      return;

    }

    if (onReset) {

      onReset();

      return;

    }

    clearReference();

  }

  // ==========================================================
  // SEARCH
  // ==========================================================

  function handleSearch() {

    if (readOnly) {

        return;

    }

    if (

        !employeeSelected ||

        !data.expense_source ||

        !data.reference_type

    ) {

        return;

    }

    // ==========================================================
    // INITIAL LOOKUP COLUMNS
    // ==========================================================

    if (

        data.reference_type === "SERVICE_VISIT"

    ) {

        setLookupColumns([

            {
                field: "reference_number",
                title: "Visit No"
            },

            {
                field: "ticket_number",
                title: "Ticket No"
            },

            {
                field: "customer_name",
                title: "Customer"
            },

            {
                field: "engineer_name",
                title: "Engineer"
            },

            {
                field: "status",
                title: "Status"
            }

        ]);

    }

    else if (

        data.reference_type === "SERVICE_TICKET"

    ) {

        setLookupColumns([

            {
                field: "reference_number",
                title: "Ticket No"
            },

            {
                field: "customer_name",
                title: "Customer"
            },

            {
                field: "contact_person",
                title: "Contact"
            },

            {
                field: "priority",
                title: "Priority"
            },

            {
                field: "status",
                title: "Status"
            }

        ]);

    }

    setLookupRows([]);

setLookupSearch("");

setShowLookup(true);

// ==========================================
// Automatically load first page
// ==========================================

setTimeout(() => {

    searchLookup("");

}, 100);

}

  // ==========================================================
// LOAD EXPENSE SOURCES
// ==========================================================

useEffect(() => {

    loadExpenseSources();

}, []);

useEffect(() => {

    if (!data.expense_source) {

        setReferenceTypes([]);

        return;

    }

    loadReferenceTypes(
        data.expense_source
    );

}, [data.expense_source]);


// ==========================================================
// SEARCH BUSINESS REFERENCES
// ==========================================================

async function searchLookup(
    searchText = lookupSearch
) {

    try {

        setLookupLoading(true);

        const result =
            await businessReferenceService.searchBusinessReference({

                employee_id: data.employee_id,

                expense_source: data.expense_source,

                reference_type: data.reference_type,

                search: searchText,

                page: 1,

                per_page: 25,

            });

        
      console.log(
          "Business Reference Search Result",
          result
      );  
      setLookupRows(
             result?.rows || []
        );

    }

    catch (error) {

        console.error(

            "Lookup search failed",

            error

        );

        setLookupRows([]);

    }

    finally {

        setLookupLoading(false);

    }

}


// ==========================================================
// SELECT BUSINESS REFERENCE
// ==========================================================

async function handleLookupSelect(row) {

    try {

        const details =
          await businessReferenceService
              .getBusinessReferenceDetails(

                  row.reference_id,

                  data.expense_source,

                  data.reference_type

              );

        onChange?.({

            ...data,

            ...details,

        });

        setShowLookup(false);

    }

    catch (error) {

        console.error(

            "Failed to load Business Reference Details",

            error

        );

    }

}
// ==========================================================
// LOAD REFERENCE TYPES
// ==========================================================

async function loadReferenceTypes(
    expenseSource
) {

    try {

        const rows =

            await businessReferenceService
                .getReferenceTypes(
                    expenseSource
                );

        setReferenceTypes(
            rows || []
        );

    }

    catch (error) {

        console.error(

            "Failed to load Reference Types",

            error

        );

        setReferenceTypes([]);

    }

}

async function loadExpenseSources() {

    try {

        const rows =

            await businessReferenceService
                .getExpenseSources();

        setExpenseSources(
            rows || []
        );

    }

    catch (error) {

        console.error(

            "Failed to load Expense Sources",

            error

        );

    }

}
  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <>
    <div className="card shadow-sm mb-4">
            

      {/* ====================================================== */}
      {/* HEADER */}
      {/* ====================================================== */}

      <div className="card-header d-flex justify-content-between align-items-center">

        <h5 className="mb-0">

          <i className="fas fa-link me-2" />

          Business Reference

        </h5>

        <div className="d-flex gap-2">

          <button
            type="button"
            className="btn btn-primary btn-sm"
            disabled={
              readOnly ||
              !employeeSelected ||
              !data.expense_source ||
              !data.reference_type
            }
            onClick={handleSearch}
          >

            <i className="fas fa-search me-1" />

            Search

          </button>

          <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                disabled={
                    readOnly ||
                    (
                        !referenceLocked &&
                        !data.expense_source &&
                        !data.reference_type
                    )
                }
                onClick={handleReset}
            >

            <i className="fas fa-undo me-1" />

            Reset

          </button>

        </div>

      </div>

      {/* ====================================================== */}
      {/* EMPLOYEE NOT SELECTED */}
      {/* ====================================================== */}

      {

        !employeeSelected && (

          <div className="card-body">

            <div className="alert alert-info mb-0">

              <i className="fas fa-info-circle me-2" />

              Please select an

              <strong>

                {" "}Employee{" "}

              </strong>

              in the

              <strong>

                {" "}Expense Claim Information{" "}

              </strong>

              section before selecting a Business Reference.

            </div>

          </div>

        )

      }

      {/* ====================================================== */}
      {/* BUSINESS REFERENCE */}
      {/* ====================================================== */}

      {

        employeeSelected && (

          <div className="card-body">

            <div className="row g-3">

              {/* ================================================== */}
              {/* EXPENSE SOURCE */}
              {/* ================================================== */}

              <div className="col-md-4">

                <label className="form-label">

                  Expense Source

                  <span className="text-danger">

                    *

                  </span>

                </label>

                <select

                  className="form-select"

                  value={
                    data.expense_source || ""
                  }

                  disabled={
                    readOnly ||
                    referenceLocked
                  }

                  onChange={(e) =>
                    update(
                      "expense_source",
                      e.target.value
                    )
                  }

                >

                  <option value="">

                    Select Expense Source

                  </option>

                  {expenseSources.map((source) => (

                    <option
                      key={source.code}
                      value={source.code}
                    >

                      {source.name}

                    </option>

                  ))}

                </select>

              </div>

              {/* ================================================== */}
              {/* REFERENCE TYPE */}
              {/* ================================================== */}

              <div className="col-md-4">

                <label className="form-label">

                  Reference Type

                  <span className="text-danger">

                    *

                  </span>

                </label>

                <select
                  className="form-select"
                  value={data.reference_type || ""}
                  disabled={
                      readOnly ||
                      !data.expense_source ||
                      referenceLocked
                  }
                  onChange={(e) =>
                      update(
                          "reference_type",
                          e.target.value
                      )
                  }
              >

                  <option value="">

                      Select Reference Type

                  </option>

                  {referenceTypes.map((type) => (

                      <option
                          key={type.code}
                          value={type.code}
                      >

                          {type.name}

                      </option>

                  ))}

              </select>

              </div>

              {/* ================================================== */}
              {/* REFERENCE NUMBER */}
              {/* ================================================== */}

              <div className="col-md-4">

                <label className="form-label">

                  Reference Number

                </label>

                <input

                  type="text"

                  className="form-control"

                  readOnly

                  value={
                    data.reference_number || ""
                  }

                  placeholder="Select using Search"

                />

              </div>

            </div>

            <hr />

            {
                data.reference_id && (

                    <div
                         className="border rounded bg-light p-2 mb-3"
                    >

                        <div className="d-flex justify-content-between align-items-center">

                            <div>

                                <div className="fw-semibold text-success">

                                    <i className="fas fa-check-circle me-2" />

                                    {data.reference_type === "SERVICE_VISIT"
                                        ? "Service Visit"
                                        : "Service Ticket"}

                                    {" : "}

                                    {data.reference_number}

                                </div>

                                <div
                                    className="small mt-1"
                                    style={{
                                        color: "#495057",
                                        lineHeight: "1.4",
                                    }}
                                >

                                    <strong>Ticket :</strong>

                                    {" "}

                                    {data.ticket_no || "-"}

                                    {" | "}

                                    <strong>Customer :</strong>

                                    {" "}

                                    {data.customer_name || "-"}

                                    {" | "}

                                    <strong>Engineer :</strong>

                                    {" "}

                                    {data.engineer_name ||

                                    data.assigned_engineer ||

                                    "-"}

                                </div>

                            </div>

                            <button
                                type="button"
                                className="btn btn-link text-decoration-none"

                                onClick={() =>
                                    setShowReferenceDetails(
                                        !showReferenceDetails
                                    )
                                }
                            >

                                {

                                  showReferenceDetails

                                      ? (
                                          <>
                                              <i className="fas fa-chevron-up me-1" />
                                              Hide Reference Details
                                          </>
                                      )

                                      : (
                                          <>
                                              <i className="fas fa-chevron-down me-1" />
                                              Show Reference Details
                                          </>
                                      )

                              }

                            </button>

                        </div>

                    </div>

                )

            }

                        {

                        showReferenceDetails && (

                        <>
                        <div className="row">

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Customer

                </small>

                <div className="fw-semibold">

                  {data.customer_name || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Contact Person

                </small>

                <div className="fw-semibold">

                  {data.contact_person || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Mobile

                </small>

                <div className="fw-semibold">

                  {data.contact_number || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Engineer

                </small>

                <div className="fw-semibold">

                  {

                    data.engineer_name ||

                    data.assigned_engineer ||

                    "-"

                  }

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Ticket No

                </small>

                <div className="fw-semibold">

                  {data.ticket_no || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Visit No

                </small>

                <div className="fw-semibold">

                  {data.visit_no || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Visit Date

                </small>

                <div className="fw-semibold">

                  {data.visit_datetime || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Status

                </small>

                <div className="fw-semibold">

                  {

                    data.visit_status ||

                    data.status ||

                    "-"

                  }

                </div>

              </div>

            </div>

            <hr />

            <div className="row">

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Priority

                </small>

                <div className="fw-semibold">

                  {data.priority || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Category

                </small>

                <div className="fw-semibold">

                  {data.category || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Instance ID

                </small>

                <div className="fw-semibold">

                  {data.instance_id || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Engine Serial No

                </small>

                <div className="fw-semibold">

                  {data.engine_serial_no || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Work Start

                </small>

                <div className="fw-semibold">

                  {data.visit_start_time || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Work End

                </small>

                <div className="fw-semibold">

                  {data.visit_end_time || "-"}

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Time Spent

                </small>

                <div className="fw-semibold">

                  {

                    data.visit_duration_minutes

                      ? `${data.visit_duration_minutes} Minutes`

                      : "-"

                  }

                </div>

              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">

                <small className="text-muted d-block">

                  Running Hours

                </small>

                <div className="fw-semibold">

                  {data.running_hours || "-"}

                </div>

              </div>

            </div>

            <hr />

            <div className="row">

              <div className="col-md-12 mb-3">

                <label className="form-label fw-semibold">

                  Start Address

                </label>

                <div
                  className="border rounded bg-light p-2"
                  style={{ minHeight: 60 }}
                >

                  {data.start_address || "-"}

                </div>

              </div>

              <div className="col-md-12 mb-3">

                <label className="form-label fw-semibold">

                  End Address

                </label>

                <div
                  className="border rounded bg-light p-2"
                  style={{ minHeight: 60 }}
                >

                  {data.end_address || "-"}

                </div>

              </div>

              <div className="col-md-12 mb-3">

                <label className="form-label fw-semibold">

                  Work Done

                </label>

                <div
                  className="border rounded bg-light p-2"
                  style={{
                    minHeight: 80,
                    whiteSpace: "pre-wrap",
                  }}
                >

                  {data.work_done || "-"}

                </div>

              </div>

              <div className="col-md-12 mb-3">

                <label className="form-label fw-semibold">

                  Observations

                </label>

                <div
                  className="border rounded bg-light p-2"
                  style={{
                    minHeight: 80,
                    whiteSpace: "pre-wrap",
                  }}
                >

                  {data.observations || "-"}

                </div>

              </div>

              <div className="col-md-12 mb-3">

                <label className="form-label fw-semibold">

                  Parts Used

                </label>

                <div
                  className="border rounded bg-light p-2"
                  style={{
                    minHeight: 80,
                    whiteSpace: "pre-wrap",
                  }}
                >

                  {data.parts_used || "-"}

                </div>

              </div>

              <div className="col-md-12">

                <label className="form-label fw-semibold">

                  Resolution Summary

                </label>

                <div
                  className="border rounded bg-light p-2"
                  style={{
                    minHeight: 80,
                    whiteSpace: "pre-wrap",
                  }}
                >

                  {data.resolution_summary || "-"}

                </div>

              </div>

            </div>

          </>

)

}
          
          </div>

        )

      }

    </div>
    <BusinessReferenceLookupDialog

        show={showLookup}

        loading={lookupLoading}

        title="Business Reference Lookup"

        searchText={lookupSearch}

        onSearchTextChange={setLookupSearch}

        onSearch={searchLookup}

        rows={lookupRows}

        columns={lookupColumns}

        onSelect={handleLookupSelect}

        onClose={() => setShowLookup(false)}

    />
      </>
  );

}